module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Motherless")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#vas_33",
      "id": "vas_1"
    }
  }, [_vm._v("2014")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Almost seventeen years had passed since Garrett Becker ")]), _vm._v("last saw his wife. More exactly, he had survived for sixteen years, six months, two weeks, and a day since grasping at her as she made her devastating exit. He had cried, sobbed actually, begged her for forgiveness. Bargained, negotiated, pleaded with her not to go.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her ears were deaf to him then, and her eyes didn’t see him now as she came down the sidewalk through heavy rain toward his SUV. They faced each other, their routes about to pass so closely, separated by just a few feet. And by eons. It would have been their twenty-second wedding anniversary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The intensity of this summer storm was unusual for the region and the time of year. Overflowing gutters, the construction of a new skyscraper, and traffic clogging the downtown Los Angeles streets brought Garrett’s vehicle to a standstill. He stared at his wife through the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sight of her, the possibility of her, set off Garrett’s pulse. A landslide of anxiety came down behind his ribs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rain sheeted his windshield, and the rhythmic wipers couldn’t keep up. Silvery water distorted the view of her face. Behind him someone honked, and he inched forward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("But she held his attention captive. Her outfit was identical to the one she wore the day she departed. Dark-blue jeans and a soft sweater, rich pink, the color of bougainvilleas. Moisture glittered her thick black hair. Crystal spray flew from the ends of her bouncing ponytail. Murky puddle water splashed around her quick feet, clad in her favorite pair of ballet flats, magenta like the sweater and studded with flashy rhinestones.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("She glided over the sidewalk, this ghost from his past. Dusk conspired with the overcast sky to keep her expression in shadow. Her gait was graceful but urgent and she hugged herself, shoulders hunched, sheltered by the awnings of downtown shops that poured waterfalls of runoff between her and Garrett. As she hurried, she leaped through the gaps between awnings, because the downpour would drench her if she didn’t keep moving.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The red taillights of the car in front of him brightened. He took too long to hit the brakes. When he did, his Suburban fishtailed in the street’s gathering river.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At the near collision she lifted her face to Garrett’s window for the space of a blink, then kept going.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In that breath her portrait was so clear. She looked so young, for all the years Garrett had aged since she’d gone. Her light step was untroubled. Stable. Free of the problems that twisted her mind and turned her heart wild after the births of their children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He twisted around in his cab to watch her, but she was lost to him, hidden by the rain and the traffic and other pedestrians. Garrett wrenched his attention back to the busy street. He moved his left hand to open the door. His body was already leaning to spring out of the Chevy and chase her down.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("But he stopped himself. There was no way in this world, in the known laws of the universe, that it could be her. There was no ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("difference between giving in to wishful thinking and being delusional, and he wasn’t the one who was delusional.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("If he could see the tiny scar on her left cheek, he’d know for sure, but that side of her profile faced away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He forced his attention to the construction zone just on the other side of oncoming traffic, where a skyscraper would soon rise from the earth like a sprouting tree. At the moment, a tall chain-link fence surrounded a thirty-foot-deep pit that occupied half a city block. The massive hole was to become the skyscraper’s foundation and basement. The task of overseeing this mighty project was Garrett’s work, the job he had finished for the day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His wife appeared in his rearview mirror. She reached the street corner behind him and looked left, down the avenue where boutiques gave way to office buildings, then right, toward the excavated pit. A passerby on the crowded sidewalk bumped into her shoulder. A man in an outdated maroon beret. He brought to mind the film director Ingmar Bergman in the early years of his career. Built like him too. Tall, slim, angular. He carried an umbrella. Garrett’s wife twisted toward the man, and they exchanged apologies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Garrett’s self-restraint snapped. The woman was no ghost. And he was "), _c('i', [_vm._v("not")]), _vm._v(" delusional.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The car in front of him finally inched ahead, and Garrett used the margin to yank his steering wheel into a U-turn. His wedding ring, the ring she’d once slipped onto his finger with a promise, bit into his skin as he pulled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The oncoming driver of a small, energy-efficient hybrid lay on the horn and gesticulated, but yielded to the brute size of the Suburban. Garrett forced his way through. A chorus of offended drivers objected, but what could they do to stop him, really?")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("The engineering part of his mind also raised a ruckus. It knew he didn’t have enough space to complete the illegal turn. His vehicle was too big, his steering radius too long. But Garrett was committed. As he came around, he drove up onto the opposite sidewalk and met the chain-link barrier that surrounded the pit. His headlights cut across the dripping gray mesh, and then his bumper pushed against it. The metal groaned before pushing back and taking some paint off of his passenger-side fender.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The old asphalt street was coated with excavated dirt that had escaped the dump trucks and turned to mud in the downpour. The back end of Garrett’s vehicle slipped a little as he stepped on the gas. He leaned across the steering wheel, eyes straining through the liquid windshield. He guessed she would turn left, around that corner, in which case he’d lose sight of her. He’d have to abandon the car and follow her on foot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But she surprised him. She asked the man in the beret a question. He pointed at the work site. She nodded a good-bye and stepped off the street corner, then cut through gridlocked cars toward the construction zone. She began to run toward the skyscraper pit, open like a sore, as if it could give her shelter. Within two splashing steps, raindrops doused her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The traffic had nowhere to go, so Garrett kept his SUV on that sidewalk, where pedestrians were temporarily barred. He accelerated. The passenger-side mirror rattled that fence like a boy with a stick. Husband and wife moved toward the same point, their paths on collision as she aimed for the barrier. She approached without breaking stride, then reached up her hands and stuck her long, narrow foot into one of the links. She began to pull herself up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He couldn’t guess what she was doing, but he feared she might go over the top. Did nobody see? Would no one step in?")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("“No!” Garrett’s shout was loud in the confined space. Then louder, “Wait!”")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Driving was the fastest way to reach her. He unbuckled his seat belt, preparing to leap out. She had both feet in the chain links now, but she paused there. The whole fence vibrated as Garrett’s mirror slid along its musical scale.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened his door and sideswiped a car in the lane he was trying to bypass. Metal squealed on metal, and muddy water splashed up into the footwell until Garrett corrected his error. He pulled the wheel to the right, and the Suburban leaned into the chain links. His door stayed open. The metallic groans on both sides deepened. He felt the right front tire leave the sidewalk and slip under the fence. Too late, he braked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She turned her head to look at him, and no amount of rain could distort the connection their eyes made. Garrett believed she saw him clearly. Saw him, knew him, and somehow had expected to meet him exactly like this and at precisely this moment as he drove his SUV into the fence like a stone into a slingshot’s rubber pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sprang off the fence, eyes still on him. The flexible soles of her slim ballet flats stayed wedged in the links, like the chain-link memorials stuffed with tributes to loved ones after unthinkable disasters. The groaning metal extended to its limits.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("His tires quickly left the solid ground. They chipped away the tiny lip of earth underneath the fence, above the excavation, and gravity took care of the rest. The vehicle tipped to the right. His door slammed shut. Everything strained, just long enough for Garrett to hope the chain-link slingshot might shoot him back onto the street. He might at least get the chance to say good-bye to his children, to explain a few things. They had never understood ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("their mother’s abandonment. How much less sense would his own exit make?")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked for her. She had withdrawn, backing away into the frozen traffic, where all eyes were on his catastrophe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Suburban tipped past the point of no return. He tried again to open his door and found the weight of the world holding it against him. The fence posts whined and then collapsed, and his head crashed into the cab’s ceiling as everything plummeted. His feet pointed to the sky. His arms braced for hell.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec9de842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 84
// module chunks = 0